import React from 'react'
import './Navlist.css'
import close from '../../../img_2/close.png'
import gamelist_img from '../../../img_2/gamelist.png'
import log1 from '../../../img_2/adventure.png'
import log2 from '../../../img_2/action.png'
import log3 from '../../../img_2/sports.png'
import log4 from '../../../img_2/beauty.png'
import log5 from '../../../img_2/kids.png'
import log6 from '../../../img_2/maoxian.png'

const logArr = [log1, log2, log3, log4, log5, log6]

export default function Navlist({ flag, setflag, gamecata }) {
  const setDis = () => {
    setflag(false)
  }

  /* 跳转到分类页面 */
  // const goCate = (para) => {
  //     window.location = "/page/category?type=" + para;
  // }

  const goHome = () => {
    window.location = '/'
  }

  return (
    <div className={flag ? 'hearde-nav2' : 'hearde-nav2 nav-remove'}>
      <div className="hearde-nav_t">
        {/* 头部 */}
        <header>
          <img src={gamelist_img} alt="" className="gameList_ico" />
          <h2 onClick={goHome}>HOME</h2>
          <img src={close} alt="" onClick={setDis} className="close" />
        </header>

        {/* 列表 */}
        <ul>
          {gamecata?.map((item, i) => (
            <li key={item.name}>
              <a href={'/page/category?type=' + item.type} className="dis_a">
                <p>{item.name}</p>
                <img src={logArr[i]} alt="" />
              </a>
            </li>
          ))}
          <li>
            <a href="/randomhow/index.html" className="dis_a">
              <p>RandomHow</p>
            </a>
          </li>
        </ul>
      </div>

      <div className="close_box" onClick={setDis}></div>
    </div>
  )
}
